function updateURLState(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function capitalizeWord(word) {
    if (!word) {
        return '';
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}

const FILTER_NORMALIZATION_CONSTANTS = (() => {
    const sizeOrder = [
        'Youth X-Small',
        'Youth Small',
        'Youth Medium',
        'Youth Large',
        'Youth XL',
        'Youth XXL',
        'Youth',
        'X-Small',
        'Small',
        'Small / Medium',
        'Small / Large',
        'Medium',
        'Medium / Large',
        'Large',
        'Large / XL',
        'XL',
        '2XL',
        '3XL',
        '4XL',
        'Adult Small',
        'Adult Medium',
        'Adult Large',
        'Adult XL',
        'Adult 2XL',
        'Adult 3XL',
        'Adult 4XL',
        'Adult',
        'Intermediate',
        'Junior',
        'Senior',
        'One Size'
    ];

    const sizeLookup = {
        'yxs': 'Youth X-Small',
        'youth xsmall': 'Youth X-Small',
        'youth extra small': 'Youth X-Small',
        'ys': 'Youth Small',
        'youth small': 'Youth Small',
        'youth s': 'Youth Small',
        'ym': 'Youth Medium',
        'youth medium': 'Youth Medium',
        'youth m': 'Youth Medium',
        'yl': 'Youth Large',
        'youth large': 'Youth Large',
        'youth l': 'Youth Large',
        'yxl': 'Youth XL',
        'youth xl': 'Youth XL',
        'youth xs': 'Youth X-Small',
        'yxxl': 'Youth XXL',
        'youth xxl': 'Youth XXL',
        'youth2xl': 'Youth XXL',
        'youth 2xl': 'Youth XXL',
        'youth': 'Youth',
        'xsmall': 'X-Small',
        'x-small': 'X-Small',
        'xs': 'X-Small',
        'small': 'Small',
        's': 'Small',
        'sm': 'Small',
        's/m': 'Small / Medium',
        's m': 'Small / Medium',
        'small/medium': 'Small / Medium',
        'small medium': 'Small / Medium',
        's/l': 'Small / Large',
        's l': 'Small / Large',
        'small/large': 'Small / Large',
        'medium': 'Medium',
        'm': 'Medium',
        'med': 'Medium',
        'm/l': 'Medium / Large',
        'ml': 'Medium / Large',
        'medium/large': 'Medium / Large',
        'large': 'Large',
        'l': 'Large',
        'large/xl': 'Large / XL',
        'l/xl': 'Large / XL',
        'xl': 'XL',
        'xlarge': 'XL',
        'x-large': 'XL',
        'x': 'XL',
        '2xl': '2XL',
        'xxl': '2XL',
        'xxxl': '3XL',
        '3xl': '3XL',
        '4xl': '4XL',
        'adultsmall': 'Adult Small',
        'adult small': 'Adult Small',
        'adultmedium': 'Adult Medium',
        'adult medium': 'Adult Medium',
        'adultlarge': 'Adult Large',
        'adult large': 'Adult Large',
        'adult l': 'Adult Large',
        'adultxl': 'Adult XL',
        'adult xl': 'Adult XL',
        'adult xs': 'Adult Small',
        'adult s': 'Adult Small',
        'adult m': 'Adult Medium',
        'adult 2xl': 'Adult 2XL',
        'adult 3xl': 'Adult 3XL',
        'adult 4xl': 'Adult 4XL',
        'adult2xl': 'Adult 2XL',
        'adult3xl': 'Adult 3XL',
        'adult4xl': 'Adult 4XL',
        'adult': 'Adult',
        'as': 'Adult Small',
        'am': 'Adult Medium',
        'al': 'Adult Large',
        'axl': 'Adult XL',
        'intermediate': 'Intermediate',
        'junior': 'Junior',
        'senior': 'Senior',
        'onesize': 'One Size',
        'one size': 'One Size',
        'one-size': 'One Size'
    };

    const sizePriority = sizeOrder.reduce((acc, label, index) => {
        acc[label] = index;
        return acc;
    }, {});

    const sizeShort = {
        'X-Small': 'XS',
        'XS': 'XS',
        'Small': 'S',
        'S': 'S',
        'Small / Medium': 'S/M',
        'Medium': 'M',
        'M': 'M',
        'Medium / Large': 'M/L',
        'Large': 'L',
        'L': 'L',
        'Large / XL': 'L/XL',
        'XL': 'XL',
        'X-Large': 'XL',
        '2XL': '2XL',
        'XXL': '2XL',
        '3XL': '3XL',
        '4XL': '4XL',
        'One Size': 'One Size'
    };

    const sizeDisplay = {
        'XXS': 'XX-Small',
        'XS': 'X-Small',
        'S': 'Small',
        'S/M': 'Small/Medium',
        'M': 'Medium',
        'M/L': 'Medium/Large',
        'L': 'Large',
        'L/XL': 'Large/XL',
        'XL': 'XL',
        '2XL': '2XL',
        '3XL': '3XL',
        '4XL': '4XL',
        'One Size': 'One Size'
    };

    const shortOrder = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
    const shortRank = shortOrder.reduce((acc, label, index) => {
        acc[label] = index;
        return acc;
    }, {});

    return {
        sizeOrder,
        sizeLookup,
        sizePriority,
        sizeShort,
        sizeShortRank: shortRank,
        sizeDisplay
    };
})();

function normalizationParseConfig(element) {
    if (!element) {
        return {};
    }
    const raw = element.dataset && element.dataset.normalizationConfig;
    if (!raw) {
        return {};
    }
    try {
        return JSON.parse(raw);
    } catch (error) {
        console.warn('Unable to parse filter normalization config', error);
        return {};
    }
}

function normalizationKey(value) {
    return (value || '')
        .toString()
        .toLowerCase()
        .replace(/&amp;/g, 'and')
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}


function canonicalizeApparelSize(label) {
    const raw = (label || '').toLowerCase();

    const primaryTokens = raw
        .replace(/&/g, ' ')
        .split(/[\|,\/]+/g)
        .map((piece) => piece.trim())
        .filter(Boolean);

    const combinedTokens = [];

    primaryTokens.forEach((token) => {
        if (!token) {
            return;
        }

        if (token.includes('-') || token.includes('–')) {
            token
                .split(/[-–]+/g)
                .map((segment) => segment.trim())
                .filter(Boolean)
                .forEach((segment) => combinedTokens.push(segment));
        } else {
            combinedTokens.push(token);
        }
    });

    const sizeLookup = FILTER_NORMALIZATION_CONSTANTS.sizeLookup;
    const sizePriority = FILTER_NORMALIZATION_CONSTANTS.sizePriority;
    const shortLookup = FILTER_NORMALIZATION_CONSTANTS.sizeShort;
    const displayLookup = FILTER_NORMALIZATION_CONSTANTS.sizeDisplay;
    const shortRank = FILTER_NORMALIZATION_CONSTANTS.sizeShortRank;

    const normalizedTokens = [];
    const seen = new Set();

    combinedTokens.forEach((piece) => {
        const clean = piece.replace(/\s+/g, ' ').trim();
        if (!clean) {
            return;
        }
        if (clean.includes('/') || clean.includes('|')) {
            return;
        }

        const lookupKey = clean.replace(/\s+/g, ' ');
        const tightKey = clean.replace(/[^a-z0-9]+/g, '');
        const mapped =
            sizeLookup[lookupKey] ||
            sizeLookup[tightKey] ||
            sizeLookup[clean] ||
            clean.replace(/\b\w/g, (c) => c.toUpperCase());

        if (!seen.has(mapped)) {
            seen.add(mapped);
            normalizedTokens.push(mapped);
        }
    });

    if (!normalizedTokens.length) {
        return label;
    }

    const groups = {};
    const groupOrder = [];

    normalizedTokens.forEach((token) => {
        const match = token.match(/^(Youth|Adult)\s+(.*)$/i);
        let prefix = '';
        let baseLabel = token;

        if (match) {
            prefix = capitalizeWord(match[1]);
            baseLabel = match[2].trim();
        }

        const priority = sizePriority[token] ?? sizePriority[baseLabel] ?? 999;
        const short = shortLookup[baseLabel] || shortLookup[token] || baseLabel;
        const rank = shortRank[short];
        const eligible = (typeof rank === 'number');

        const groupKey = prefix || '';
        if (!groups[groupKey]) {
            groups[groupKey] = [];
            groupOrder.push(groupKey);
        }

        groups[groupKey].push({
            token,
            prefix,
            baseLabel,
            priority,
            short,
            rank,
            eligible
        });
    });

    const results = [];

    const pushResult = (value) => {
        if (!results.some((existing) => normalizationKey(existing) === normalizationKey(value))) {
            results.push(value);
        }
    };

    groupOrder.forEach((groupKey) => {
        const items = groups[groupKey];

        items.sort((a, b) => {
            const rankA = typeof a.rank === 'number' ? a.rank : a.priority;
            const rankB = typeof b.rank === 'number' ? b.rank : b.priority;

            if (rankA === rankB) {
                return a.short.localeCompare(b.short);
            }
            return rankA - rankB;
        });

        let run = [];

        const formatSingle = (item) => {
            const baseDisplay = displayLookup[item.short] || item.short;
            const value = item.prefix ? `${item.prefix} ${baseDisplay}` : baseDisplay;
            pushResult(value);
        };

        const formatRange = (first, last) => {
            const startDisplay = displayLookup[first.short] || first.short;
            const endDisplay = displayLookup[last.short] || last.short;
            let summary = startDisplay;
            if (startDisplay !== endDisplay) {
                summary = `${startDisplay} to ${endDisplay}`;
            }
            if (first.prefix) {
                summary = `${first.prefix} ${summary}`;
            }
            pushResult(summary);
        };

        const flush = () => {
            if (!run.length) {
                return;
            }

            const anyIneligible = run.some((item) => !item.eligible);

            if (run.length === 1 || anyIneligible) {
                run.forEach(formatSingle);
            } else {
                const first = run[0];
                const last = run[run.length - 1];
                formatRange(first, last);
            }

            run = [];
        };

        items.forEach((item) => {
            if (!run.length) {
                run.push(item);
                return;
            }

            const previous = run[run.length - 1];
            const adjacent =
                item.eligible &&
                previous.eligible &&
                typeof item.rank === 'number' &&
                typeof previous.rank === 'number' &&
                Math.abs(item.rank - previous.rank) === 1;

            if (adjacent) {
                run.push(item);
            } else {
                flush();
                run.push(item);
            }
        });

        flush();
    });

    if (!results.length) {
        return label;
    }

    return results.join(' / ');
}

function canonicalizeLabel(groupLabel, label, config) {
    const groupKey = normalizationKey(groupLabel);
    const labelKey = normalizationKey(label);

    let canonical = label.trim();

    const groupConfig = Object.keys(config || {}).find(
        (key) => normalizationKey(key) === groupKey
    );

    if (groupConfig && config[groupConfig]) {
        const match = Object.keys(config[groupConfig]).find(
            (candidate) => normalizationKey(candidate) === labelKey
        );
        if (match) {
            canonical = config[groupConfig][match];
        } else if (console && console.warn) {
            console.warn(
                `[Filter Normalization] Unmapped value "${label}" in group "${groupLabel}". ` +
                `Add to config: "${labelKey}": "Canonical Name"`
            );
        }
    }

    if (
        groupKey === normalizationKey('Apparel Size') ||
        groupKey === normalizationKey('Size') ||
        groupKey === normalizationKey('Accessory size')
    ) {
        canonical = canonicalizeApparelSize(canonical);
    }

    if (groupKey === normalizationKey('Gender')) {
        const segments = canonical
            .split('/')
            .map((segment) => segment.replace(/\s+/g, ' ').trim())
            .filter(Boolean);

        const excludedGenders = ['Youth', 'Male', 'Female', 'Unisex'];
        const filtered = [];
        segments.forEach((segment) => {
            if (excludedGenders.some((excluded) => normalizationKey(segment) === normalizationKey(excluded))) {
                return;
            }
            if (!filtered.some((existing) => normalizationKey(existing) === normalizationKey(segment))) {
                filtered.push(segment);
            }
        });

        if (!filtered.length) {
            return null;
        }

        canonical = filtered.join(' / ');
    }

    if (typeof canonical === 'string') {
        canonical = canonical.trim();
    }

    if (!canonical) {
        return null;
    }

    return canonical;
}

function updatePagination(searchParams){
    var paginationLinks = document.querySelectorAll('.products-pagination a');

    var existingSearchParams = new URLSearchParams(searchParams);

    for( let link of paginationLinks ){

        var searchParamsArray = {};
        var urlBase = link.getAttribute('href').split('?')[0];
        var url = link.getAttribute('href').split('?')[1];
        var urlParams = new URLSearchParams(url);
       
        for(const entry of urlParams.entries()) {
            searchParamsArray[entry[0]] = entry[1];
        }

        // Don't decode parameter names (breaks filter.p.m.magento.manufacturer)
        // Don't overwrite 'page' parameter from pagination link
        for(const existingEntry of existingSearchParams.entries()){
            if(existingEntry[0] !== 'page') {
                searchParamsArray[existingEntry[0]] = decodeURIComponent(existingEntry[1]);
            }
        }

        // Build query string manually to preserve dots in parameter names
        // Filter out empty values
        var newUrlParams = Object.keys(searchParamsArray)
            .filter(key => searchParamsArray[key] && searchParamsArray[key].length > 0)
            .map(key => key + '=' + encodeURIComponent(searchParamsArray[key]))
            .join('&');
        var newUrl = urlBase + '?' + newUrlParams;
        link.setAttribute('href', newUrl)
    }


}

/**
 * NEW: Shared helper used by both the checkbox/price filters (ProductFilters)
 * and the Sort dropdown (SortingDropdown) to build the *current, live*
 * set of active filter params.
 *
 * Why this exists:
 * Previously, SortingDropdown read `window.location.search` to figure out
 * which filters were active. If any filter UI (including apps like
 * Search & Discovery) updates the product grid via AJAX WITHOUT calling
 * history.pushState() to sync the address bar, `window.location.search`
 * goes stale — it no longer reflects the actually-applied filters.
 * That caused: "select Marucci filter -> change sort -> shows ALL products".
 *
 * This function instead reads the live DOM state of the filter form
 * (checked checkboxes, price inputs, hidden q input) via FormData, which
 * is always accurate regardless of whether any app synced the URL bar.
 * It falls back to window.location.search only if no filter form exists
 * on the page at all.
 *
 * It also fixes a duplicate-key bug: using a plain object to collect
 * params (as the old code did) silently drops all but the last value
 * when multiple checkboxes share the same name (e.g. two sizes selected).
 * URLSearchParams correctly preserves repeated keys.
 */
function getActiveFilterSearchParams() {
    var params = new URLSearchParams();

    var filtersRoot = document.querySelector('facet-filters');
    var form = filtersRoot ? filtersRoot.querySelector('form') : null;

    if (form) {
        var formData = new FormData(form);
        for (const [key, value] of formData.entries()) {
            if (value !== null && value !== undefined && String(value).length > 0) {
                params.append(key, value);
            }
        }

        // Ensure `q` (search term) is included even if it's not inside the form
        var qField = document.querySelector("[name='q']");
        if (qField && qField.value && !params.has('q')) {
            params.append('q', qField.value);
        }
    } else {
        // Fallback: no filter form present on the page at all, use URL bar
        var fallbackParams = new URLSearchParams(window.location.search);
        for (const [key, value] of fallbackParams.entries()) {
            if (key === 'page') {
                continue;
            }
            if (value && value.length > 0) {
                params.append(key, value);
            }
        }
    }

    return params;
}


// Filters & Sorting
class ProductFilters extends HTMLElement{
    constructor(){
        super();


        // To check is element added
        // if (!customElements.get('quick-add-modal')) {

        // }

        this.form = this.querySelector('form');
        this.details = this.getElementsByTagName('details');
        this.submitButtons = this.querySelectorAll('button[type="submit"]')

        this.filterDrawerToggle = this.querySelector('.facet-filters-toggle');
        this.filterDrawerContent = this.querySelector('.facet-filters-content');
        this.filterDrawerOverlay = this.querySelector('.facet-filters-form-overlay');
        this.filterDrawerClose = this.querySelector('.facet-filters-list-close');

        // Mobile filter Drawer
        this.mobileFilterClick();

        // Close filter dropdown when out of range
        // this.filterClose();

        // Ajax Filter
        this.ajaxFilter();

        // Price Range filter
        var priceSliderBase = document.querySelector('.price-range-handle-base');
        if(priceSliderBase){
            this.priceRangeSlider();
        }

        this.normalizationConfig = normalizationParseConfig(this);
        this.initializeNormalization();
    }

    mobileFilterClick = () => {
        this.filterDrawerToggle.addEventListener('click', (e) => {
            e.preventDefault();
            
            if( this.filterDrawerContent.classList.contains('active') ){
                this.filterDrawerContent.classList.remove('active');
            }
            else{
                this.filterDrawerContent.classList.add('active');
            }
        })

        document.addEventListener('click', (event) => {
            // this.details = this.getElementsByTagName('details');
            // for(let detail of this.details){
            var filterDrawerClose = document.querySelector('.facet-filters-list-close');
            if (event.target == filterDrawerClose || filterDrawerClose.contains(event.target)) {
                this.filterDrawerContent.classList.remove('active');
            }
            // }
        })

        this.filterDrawerOverlay.addEventListener('click', (e) => {
            // e.preventDefault();
            // console.log("clicked close")
            this.filterDrawerContent.classList.remove('active');
            
        })
    }

    


    filterClose = () => {
        document.addEventListener('click', (event) => {
            this.details = this.getElementsByTagName('details');
            for(let detail of this.details){
                if (event.target !== detail && !detail.contains(event.target)) {
                    detail.removeAttribute('open');
                }
            }
        })
    }

    ajaxFilter = () => {

        document.addEventListener('change', (event) => {
            var filterInputElements = this.querySelectorAll('input[type="checkbox"], input[type="number"]');
            filterInputElements.forEach(filterInputElement => {

                if (event.target == filterInputElement || filterInputElement.contains(event.target)) {
                    // console.log("change triggered");
                    this.ajaxFiltering(event);
                }
            })
        })

        document.addEventListener('keyup', (event) => {
            if(event.key == 'Enter'){   
                
                var filterInputElements = this.querySelectorAll('.filter-group-display__list-item');
                filterInputElements.forEach(filterInputElement => {
                    if (event.target == filterInputElement || filterInputElement.contains(event.target)) {
                        // console.log("change triggered");
                        filterInputElement.querySelector('input[type="checkbox"], input[type="number"]').click();
                    }
                })
            }
        })

        var filterPriceRangeMin = this.querySelector('.price-range-handle-min');
        var filterPriceRangeMax = this.querySelector('.price-range-handle-max');


        document.addEventListener('keyup', (event) => {
            var focusedMin = this.querySelector('.price-range-handle-min:focus-visible');
            var focusedMax = this.querySelector('.price-range-handle-max:focus-visible');
            if(event.key == 'Tab'){
                if(focusedMin){
                    this.isDraggingMin = true 
                    this.isDraggingMax = false 
                }
                if(focusedMax){
                    this.isDraggingMax = true 
                    this.isDraggingMin = false 
                }

                if(focusedMin == null && focusedMax == null){
                    this.isDraggingMax = false 
                    this.isDraggingMin = false 
                }
            }

            if(event.key == 'Enter'){
                if(focusedMin || focusedMax){
                    this.ajaxFiltering(event);
                }
            }
        });

        var priceSliderBase = document.querySelector('.price-range-handle-base');
        if(priceSliderBase){
            var priceSliderWidth = priceSliderBase.offsetWidth
            var currentOffset = 0
            var currentOffsetLeft = 0
            var currentOffsetRight = 240
            document.addEventListener('keydown', (event) => { 
                if(event.key == 'ArrowLeft'){   
                    if(this.isDraggingMin){
                        currentOffset = currentOffset - 10;
                    }
                    if(this.isDraggingMax){
                        currentOffset = currentOffset + 10;
                    }
                }

                if(event.key == 'ArrowRight'){    
                    if(this.isDraggingMin){
                        currentOffset = currentOffset + 10;
                    }
                    if(this.isDraggingMax){
                        currentOffset = currentOffset - 10;
                    }
                }
                
                if(this.isDraggingMin){
                    this.onMove(event, currentOffset);
                }
                if(this.isDraggingMax){
                    this.onMove(event, (priceSliderWidth - currentOffset));
                }
            })
        }

    }

    initializeNormalization = () => {
        this.normalizedGroups = {};
        this.synonymLookup = {};

        this.normalizeFilterOptions();
        this.updateActiveFilters();
    }

    normalizeFilterOptions = () => {
        const config = this.normalizationConfig || {};
        const lists = this.querySelectorAll('.filter-group-display__list');
        const collectionHandle = (this.dataset.collectionHandle || '').toLowerCase();
        const skipApparelSize =
            collectionHandle.includes('bat') ||
            collectionHandle.includes('glove');
        const canonicalGroups = {};
        const synonymLookup = {};

        lists.forEach((list) => {
            const groupElement = list.closest('.filter-group');
        if (!groupElement) {
            return;
        }
        const summary = groupElement.querySelector('.filter-group-summary span');
            const groupLabel = summary ? summary.textContent.trim() : '';
            if (!groupLabel) {
                return;
            }
            if (groupLabel === 'Apparel Size' && skipApparelSize) {
                if (groupElement) {
                    groupElement.remove();
                }
                return;
            }
            if (groupLabel === 'Apparel Color') {
                groupElement.remove();
                return;
            }

        Array.from(list.querySelectorAll('.filter-group-display__list-item')).forEach((item, index) => {
            const labelElement = item.querySelector('.filter-group-display__list-item-label');
            const inputElement = item.querySelector('input[type="checkbox"]');
            if (!labelElement || !inputElement) {
                    return;
                }

                const originalLabel = labelElement.textContent.trim();
                const canonicalLabel = canonicalizeLabel(groupLabel, originalLabel, config);
                if (!canonicalLabel) {
                    item.remove();
                    return;
                }

                // Store canonical label for debugging
                item.dataset.canonicalLabel = canonicalLabel;
                item.dataset.normalizedKey = normalizationKey(`${groupLabel} ${canonicalLabel}`);

                const groupKey = normalizationKey(`${groupLabel}::${canonicalLabel}`);
                const originalLookupKey = normalizationKey(`${groupLabel}::${originalLabel}`);

                let group = canonicalGroups[groupKey];

                if (!group) {
                    group = {
                        groupLabel,
                        canonicalLabel,
                        normalizedKey: groupKey,
                        masterItem: item,
                        masterInput: inputElement,
                        hiddenInputs: [],
                        originalLabels: [],
                        values: [],
                        active: false,
                        count: 0
                    };
                    canonicalGroups[groupKey] = group;
                    labelElement.textContent = canonicalLabel;
                }

                const countValue = Number(item.dataset.filterCount || 0);
                if (!Number.isNaN(countValue)) {
                    group.count += countValue;
                }

                group.originalLabels.push(originalLabel);
                group.values.push(inputElement.value);
                if (inputElement.checked) {
                    group.active = true;
                }

                item.dataset.canonicalLabel = canonicalLabel;
                item.dataset.normalizedKey = groupKey;
                item.dataset.originalLabel = originalLabel;

                if (group.masterItem !== item) {
                    const hiddenInput = inputElement.cloneNode(true);
                    hiddenInput.checked = inputElement.checked;
                    hiddenInput.hidden = true;
                    hiddenInput.setAttribute('aria-hidden', 'true');
                    hiddenInput.tabIndex = -1;
                    hiddenInput.removeAttribute('id');
                    hiddenInput.classList.add('filter-normalization-hidden-input');
                    group.masterItem.appendChild(hiddenInput);
                    group.hiddenInputs.push(hiddenInput);
                    item.remove();
                }

                synonymLookup[originalLookupKey] = group;
            });

            // Remove empty filter groups
            const remainingItems = list.querySelectorAll('.filter-group-display__list-item');
            if (remainingItems.length === 0) {
                const groupElement = list.closest('.filter-group');
                if (groupElement) {
                    groupElement.remove();
                }
            }
        });

        Object.values(canonicalGroups).forEach((group) => {
            const isChecked = group.active;
            group.masterInput.checked = isChecked;
            group.hiddenInputs.forEach((hidden) => {
                hidden.checked = isChecked;
            });

            if (group.count && group.masterItem) {
                group.masterItem.dataset.filterCount = group.count;
            }

            const syncHiddenInputs = () => {
                const checkedState = group.masterInput.checked;
                group.hiddenInputs.forEach((hidden) => {
                    hidden.checked = checkedState;
                });
            };

            group.masterInput.addEventListener('change', syncHiddenInputs);
        });

        this.normalizedGroups = canonicalGroups;
        this.synonymLookup = synonymLookup;
    }

    updateActiveFilters = () => {
        const activeContainer = this.querySelector('.active-filters');
        if (!activeContainer) {
            return;
        }

        const links = Array.from(activeContainer.querySelectorAll('.active-filters__remove-filter'));
        if (!links.length) {
            return;
        }

        const seen = new Map();
        links.forEach((link) => {
            const originalLabel = (link.dataset.originalLabel || link.textContent || '').trim();
            const groupLabel = (link.dataset.filterGroup || '').trim();
            const canonicalLabel = canonicalizeLabel(groupLabel, originalLabel, this.normalizationConfig);
            if (!canonicalLabel) {
                link.remove();
                return;
            }
            const seenKey = normalizationKey(`${groupLabel}::${canonicalLabel}`);

            const icon = link.querySelector('svg');
            if (icon) {
                icon.remove();
            }
            link.textContent = `${canonicalLabel} `;
            if (icon) {
                link.appendChild(icon);
            }

            const canonicalGroupKey = normalizationKey(`${groupLabel}::${canonicalLabel}`);
            const originalLookupKey = normalizationKey(`${groupLabel}::${originalLabel}`);
            const group =
                this.normalizedGroups[canonicalGroupKey] ||
                this.synonymLookup[canonicalGroupKey] ||
                this.synonymLookup[originalLookupKey];

            if (!seen.has(seenKey)) {
                seen.set(seenKey, link);
                link.classList.remove('filter-normalization-hidden');
                link.removeAttribute('hidden');
                link.removeAttribute('aria-hidden');
                if (group) {
                    this.bindActiveFilterLink(link, group);
                }
            } else {
                link.classList.add('filter-normalization-hidden');
                link.setAttribute('hidden', 'true');
                link.setAttribute('aria-hidden', 'true');
            }
        });
    }

    bindActiveFilterLink = (link, group) => {
        if (!link || !group || link.dataset.normalizationBound === 'true') {
            return;
        }

        link.dataset.normalizationBound = 'true';
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const masterInput = group.masterInput;
            const hiddenInputs = group.hiddenInputs || [];

            const wasChecked = masterInput.checked || hiddenInputs.some((input) => input.checked);
            if (!wasChecked) {
                const href = link.getAttribute('href');
                if (href) {
                    window.location.href = href;
                }
                return;
            }

            masterInput.checked = false;
            hiddenInputs.forEach((input) => {
                input.checked = false;
            });

            this.ajaxFiltering(event);
        });
    }


    getParams(){

        const formData = new FormData(this.form);
        return new URLSearchParams(formData).toString();
        
    }


    getUrlParams = () => {
        Shopify.queryParams = [];
        var queryParams = [];
        if(window.location.search.length) {
            
          for(var aKeyValue, i = 0, aCouples = window.location.search.substring(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                if( aKeyValue[1].length > 0 ){

                    if( aKeyValue[0] != 'page' ){
                        // Don't decode parameter names (breaks filter.p.m.magento.manufacturer)
                        queryParams.push({ key: aKeyValue[0], value: decodeURIComponent(aKeyValue[1])});
                    }
                }
            }
          }
        }

        var formParams = this.getParams();

        var getSearchParam = document.querySelector("[name='q']");
        if(getSearchParam){
          Shopify.queryParams.push({ key: decodeURIComponent('q'), value: decodeURIComponent(getSearchParam.value)});
        }

        // Preserve sort_by across filter changes: the filter form itself
        // has no sort_by field, so without this, checking a filter would
        // silently reset sorting back to default.
        var existingSortBy = new URLSearchParams(window.location.search).get('sort_by');
        if (existingSortBy) {
            Shopify.queryParams.push({ key: 'sort_by', value: existingSortBy });
        }

        if(formParams.length) {
            for(var aKeyValue, i = 0, aCouples = formParams.split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    // Don't decode parameter names (breaks filter.p.m.magento.manufacturer)
                    Shopify.queryParams.push({ key: aKeyValue[0], value: decodeURIComponent(aKeyValue[1])});
                }
            }
        }

        var combinedQueryParams = [...Shopify.queryParams];
        var params = '';

        combinedQueryParams.forEach((param, index) => {
            params += `${param['key']}=${param['value']}`; 

            if( (index + 1) != combinedQueryParams.length ){
                params += `&`;
            }
        })

        return params;
    }

    ajaxFiltering = (event) => {


        var searchParams = this.getUrlParams();
        // console.log("search params", searchParams);

        var productsSelector = '.products';
        var filtersSelector = '.facet-filters';
        var productsSection = document.querySelector(productsSelector);
        var filtersSection = document.querySelector(filtersSelector);

        var productsSectionId = productsSection.dataset.id
        var filtersSectionId = filtersSection.dataset.id


        var priceSliderBase = document.querySelector('.price-range-handle-base');
        if(priceSliderBase){
            var handleMin = filtersSection.querySelector('.filter-group-display__price-range-slider-handle--min');
            var handleMax = filtersSection.querySelector('.filter-group-display__price-range-slider-handle--max');
            var currentHandleMinWidth = handleMin.style.width;
            var currentHandleMaxWidth = handleMax.style.width;
        }

        // Filter out empty parameters before making fetch requests
        const params = new URLSearchParams(searchParams);
        const filteredParamsArray = [];
        for (const [key, value] of params.entries()) {
            if (value && value.length > 0) {
                // Don't encode parameter names to preserve dots in filter.p.m.magento.manufacturer
                filteredParamsArray.push(key + '=' + encodeURIComponent(value));
            }
        }
        searchParams = filteredParamsArray.join('&');

        // Add page=1 to ensure pagination is respected when filtering
        if (searchParams) {
            searchParams += '&page=1';
        } else {
            searchParams = 'page=1';
        }

        fetch(`${window.location.pathname}?section_id=${filtersSectionId}&${searchParams}`)
            .then(response => {
                return response.text()
            })
            .then((text) => {

                // Insert products
                this.insertFilteredFacets(text);

                // Set Price filter width
                if(priceSliderBase){
                    this.setPriceFilterHandleWidth(currentHandleMinWidth, currentHandleMaxWidth);
                }

            });
        fetch(`${window.location.pathname}?section_id=${productsSectionId}&${searchParams}`)
            .then(response => {
                return response.text()
            })
            .then((text) => {

                // Insert products
                this.insertFilteredProducts(text);

                // Update Addressbar URL
                updateURLState(searchParams)

                // Update Pagination Links
                updatePagination(searchParams);

                // Closing dropdown
                this.closeDropdown(event);

                // Closing Drawer
                this.filterDrawerContent.classList.remove('active');

            });
    }

    closeDropdown = (event) => {
        var detail = event.target.closest('details')
        if( detail ){
            detail.removeAttribute('open');
        }
    }

    insertFilteredFacets = (text) => {

        var filtersSelector = '.facet-filters';
        var filtersSection = document.querySelector(filtersSelector + ' .filter-form');
        var filtersCountSection = document.querySelector('.facet-filters-count');

        const html = document.createElement('div');
        html.innerHTML = text;
        const newFiltersSection = html.querySelector(filtersSelector + ' .filter-form');
        const newFiltersCountSection = html.querySelector('.facet-filters-count');

        if (filtersSection && newFiltersSection) {
            filtersSection.innerHTML = newFiltersSection.innerHTML;
        }

        if (filtersCountSection && newFiltersCountSection) {
            filtersCountSection.innerHTML = newFiltersCountSection.innerHTML;
        }

        if (!filtersSection) {
            console.error('filtersSection not found');
            return;
        }

        const resultsLazyloadImages = filtersSection.querySelectorAll('.lazy-loading-image');

        resultsLazyloadImages.forEach(imageContainer => {
            lazyloading(imageContainer);
        })

        // Re-apply filter normalization after new markup is injected
        this.initializeNormalization();
    }

    insertFilteredProducts = (text) => {

        var productsSelector = '.products';
        var productsSection = document.querySelector(productsSelector);

        const html = document.createElement('div');
        html.innerHTML = text;
        const newProductsSection = html.querySelector(productsSelector);

        if (!productsSection || !newProductsSection) {
            console.error('productsSection or newProductsSection not found');
            return;
        }

        productsSection.innerHTML = newProductsSection.innerHTML;

        const resultsLazyloadImages = productsSection.querySelectorAll('.lazy-loading-image');

        resultsLazyloadImages.forEach(imageContainer => {
            lazyloading(imageContainer);
        })
        
    }

    setPriceFilterHandleWidth = (currentHandleMinWidth, currentHandleMaxWidth) => {

        var filtersSelector = '.facet-filters';
        var filtersSection = document.querySelector(filtersSelector + ' .filter-form');

        var handleMin = filtersSection.querySelector('.filter-group-display__price-range-slider-handle--min');
        var handleMax = filtersSection.querySelector('.filter-group-display__price-range-slider-handle--max');

        handleMin.style.width = currentHandleMinWidth;
        handleMax.style.width = currentHandleMaxWidth;
    }


    priceRangeSlider = () => {

        this.isDraggingMin = false,
        this.isDraggingMax = false,
        this.isOutofRange = false;


        document.addEventListener('mouseup', (event) => { 

            this.handle = this.querySelector('.filter-group-display__price-range-slider');
            this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
            this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

            this.minPriceElement = this.querySelector('.filter-group-display__price-range-from input[type="number"]');
            this.maxPriceElement = this.querySelector('.filter-group-display__price-range-to input[type="number"]');

            this.minPrice = this.minPriceElement.getAttribute('min');
            this.maxPrice = this.maxPriceElement.getAttribute('max');


            this.minWidth = this.handleMin.offsetWidth;
            this.maxWidth = this.handleMax.offsetWidth;
            this.handleWidth = this.handle.offsetWidth;

            this.priceRange = this.maxPrice - this.minPrice;
            
            this.sliderPosition = {
                top: this.handle.getBoundingClientRect().top + window.scrollY, 
                left: this.handle.getBoundingClientRect().left + window.scrollX, 
            };


            if (event.target == this.handleMin || this.handleMin.contains(event.target)) {
                this.isDraggingMin = false 

                this.ajaxFiltering(event);
            }
            if (event.target == this.handleMax || this.handleMax.contains(event.target)) {
                this.isDraggingMax = false 

                this.ajaxFiltering(event);
            }

        });
        document.addEventListener('mousedown', (event) => { 

            this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
            this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

            if (event.target == this.handleMin || this.handleMin.contains(event.target)) {
                this.isDraggingMin = true 
            }
            if (event.target == this.handleMax || this.handleMax.contains(event.target)) {
                this.isDraggingMax = true 
            }
        });

        document.addEventListener('touchend', (event) => { 

            this.handle = this.querySelector('.filter-group-display__price-range-slider');
            this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
            this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

            this.minPriceElement = this.querySelector('.filter-group-display__price-range-from input[type="number"]');
            this.maxPriceElement = this.querySelector('.filter-group-display__price-range-to input[type="number"]');

            this.minPrice = this.minPriceElement.getAttribute('min');
            this.maxPrice = this.maxPriceElement.getAttribute('max');


            this.minWidth = this.handleMin.offsetWidth;
            this.maxWidth = this.handleMax.offsetWidth;
            this.handleWidth = this.handle.offsetWidth;

            this.priceRange = this.maxPrice - this.minPrice;
            
            this.sliderPosition = {
                top: this.handle.getBoundingClientRect().top + window.scrollY, 
                left: this.handle.getBoundingClientRect().left + window.scrollX, 
            };

            if (event.target == this.handleMin || this.handleMin.contains(event.target)) {
                this.isDraggingMin = false 

                this.ajaxFiltering(event);
            }
            if (event.target == this.handleMax || this.handleMax.contains(event.target)) {
                this.isDraggingMax = false 

                this.ajaxFiltering(event);
            }
        });
        document.addEventListener('touchstart', (event) => { 

            this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
            this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

            if (event.target == this.handleMin || this.handleMin.contains(event.target)) {
                this.isDraggingMin = true 
            }

            if (event.target == this.handleMax || this.handleMax.contains(event.target)) {
                this.isDraggingMax = true 
            }
        });


        document.addEventListener('mousemove', (e) => this.onMove(e));
        document.addEventListener('touchmove', (e) => this.onMove(e));

        document.addEventListener('mouseup', (e) => { this.onMouseUp(); })
        document.addEventListener('touchend', (e) => { this.onMouseUp(); })
        document.addEventListener('mousedown', (e) => { e.key == "Escape" && this.onMouseUp(); });

    }

    onMove = (e, offsetX = null) => {

        if( !(this.isDraggingMax == true || this.isDraggingMin == true) ){
            return false;
        }

        var type = e.type;
        var pageX = e.pageX;
        if(offsetX == null){
            offsetX = e.offsetX;
        }

        if (type === "touchmove") {
            var touch = e.touches[0] || e.changedTouches[0];
            var touchOffset = 34;
            offsetX = touch.pageX - touchOffset;

        }

        this.handle = this.querySelector('.filter-group-display__price-range-slider');
        this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
        this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

        this.minPriceElement = this.querySelector('.filter-group-display__price-range-from input[type="number"]');
        this.maxPriceElement = this.querySelector('.filter-group-display__price-range-to input[type="number"]');

        this.minPrice = this.minPriceElement.getAttribute('min');
        this.maxPrice = this.maxPriceElement.getAttribute('max');



        this.minWidth = this.handleMin.offsetWidth;
        this.maxWidth = this.handleMax.offsetWidth;
        this.handleWidth = this.handle.offsetWidth;

        this.priceRange = this.maxPrice - this.minPrice;
        
        this.sliderPosition = {
            top: this.handle.getBoundingClientRect().top + window.scrollY, 
            left: this.handle.getBoundingClientRect().left + window.scrollX, 
        };


        this.isOutofRange = (this.sliderPosition.left > pageX || (this.handleWidth + this.sliderPosition.left) <= pageX) ? true : false;

        var width = Math.floor((this.priceRange * offsetX) / this.handleWidth) + parseFloat(this.minPrice);

        if (this.isDraggingMax == true && this.minWidth < offsetX && this.isOutofRange == false) {
            this.handleMax.style.width = offsetX * 100 / this.handleWidth + '%';
            this.maxPriceElement.setAttribute('val', width);
            this.maxPriceElement.value = width;
        }

        if (this.isDraggingMin == true && this.maxWidth > offsetX && this.isOutofRange == false) {
            this.handleMin.style.width = offsetX * 100 / this.handleWidth + '%';
            this.minPriceElement.setAttribute('val', width);
            this.minPriceElement.value = width;
        }

        this.minWidth = this.handleMin.offsetWidth;
        this.maxWidth = this.handleMax.offsetWidth;

    }

    onMouseUp = () => {
        this.isDraggingMin = false;
        this.isDraggingMax = false;

    }
}
customElements.define('facet-filters', ProductFilters)



class SortingDropdown extends HTMLElement{
    constructor(){
        super();

        this.dropdownToggle = this.querySelector('.facet-filters-sorting-default');
        this.sortOptions = this.querySelectorAll('li');

        this.dropdownToggle.addEventListener('click', (e)=> {
            this.onClick();
        })

        document.addEventListener('click', (event) => {
            if (event.target !== this && !this.contains(event.target)) {
                this.close()
            }
        })
        
        for( let option of this.sortOptions ){
            option.addEventListener('click', (e) => {
                this.onOptionClick(option);
            });
        }

        document.addEventListener('keyup', (event) => {
            if(event.key == 'Enter'){
                for( let option of this.sortOptions ){
                    if (event.target == option && option.contains(event.target)) {
                        this.onOptionClick(option);
                    }
                }
            }
        })
    }

    onClick = () => {
        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open();
        }
    }

    open = () => {
        this.classList.add('active');
    }

    close = () => {
        this.classList.remove('active');
    }

    onOptionClick = (option) => {
        var value = option.dataset.value;

        // FIX: previously this only read window.location.search, which can
        // go stale if any filter (e.g. Search & Discovery vendor/manufacturer
        // filter) updates the grid via AJAX without updating the address bar.
        // Now we read the live, currently-checked filter state from the DOM,
        // which is always accurate. This also fixes a duplicate-key bug where
        // multiple checked values for the same filter name used to silently
        // collapse into a single value.
        var searchParams = getActiveFilterSearchParams();

        // Remove page so sorting starts from page 1, and set the new sort value.
        searchParams.delete('page');
        searchParams.set('sort_by', value);

        this.ajaxSorting(searchParams);
    }

    ajaxSorting = (searchParamsInput) => {

        var productsSelector = '.products'
        var productsSection = document.querySelector(productsSelector);
        var productsSectionId = productsSection.dataset.id

        // Accept either a URLSearchParams instance or a plain object for
        // backwards compatibility.
        var searchParams;
        if (searchParamsInput instanceof URLSearchParams) {
            searchParams = searchParamsInput.toString();
        } else {
            searchParams = new URLSearchParams(searchParamsInput).toString();
        }

        var sortByValue = (searchParamsInput instanceof URLSearchParams)
            ? searchParamsInput.get('sort_by')
            : searchParamsInput.sort_by;

        fetch(`${window.location.pathname}?section_id=${productsSectionId}&${searchParams}`)
        .then(response => {
            return response.text()
        })
        .then((text) => {

            for( let option of this.sortOptions ){
              if( option.dataset.value == sortByValue ){
                this.dropdownToggle.querySelector('span').innerHTML = option.innerHTML
              }
            }

            const html = document.createElement('div');
            html.innerHTML = text;
            const newProductsSection = html.querySelector(productsSelector);
            
            productsSection.innerHTML = newProductsSection.innerHTML;

            const resultsLazyloadImages = productsSection.querySelectorAll('.lazy-loading-image');

            resultsLazyloadImages.forEach(imageContainer => {
                lazyloading(imageContainer);
            })

            updateURLState(searchParams)

            updatePagination(searchParams);


            this.close();

        });
    }

}
customElements.define('sorting-dropdown', SortingDropdown)

function ajaxPagination(params, productsPagination) {

    var productsSelector = '.products'
    var section = document.querySelector(productsSelector);

    fetch(`${window.location.pathname}?${params}`)
        .then(response => {
            return response.text()
        })
        .then((text) => {

            const html = document.createElement('div');
            html.innerHTML = text;
            const productsSection = html.querySelector(productsSelector);

            if( productsPagination.dataset.paginationChoice == '2' || productsPagination.dataset.paginationChoice == '3' ){
                
                productsSection.querySelectorAll('li').forEach(li => {
                    section.querySelector('ul').append(li);
                })
                
                var infiniteButton = document.querySelector('.products-pagination-infinite');
                infiniteButton.dataset.currentPage = html.querySelector('.products-pagination-infinite').dataset.currentPage;

                infiniteButton.disabled = false;

                if(infiniteButton.dataset.currentPage >= infiniteButton.dataset.totalPages){
                    infiniteButton.classList.add('hide');
                }

                if(productsPagination.dataset.paginationChoice == '3'){
                    infiniteButton.classList.add('inactive');
                }

            }
            else{
                section.innerHTML = productsSection.innerHTML;

                updateURLState(params)

                document.querySelector('.section-products').scrollIntoView({
                    behavior: "instant"
                })
            }

            // Lazyload iamges
            const resultsLazyloadImages = section.querySelectorAll('.lazy-loading-image');

            resultsLazyloadImages.forEach(imageContainer => {
                lazyloading(imageContainer);
            })

        });

}

class ProductsPagination extends HTMLElement {
    constructor(){
        super();

        if(this.dataset.paginationChoice == '2' || this.dataset.paginationChoice == '3'){
            // Pagination Infinite scroll
            this.paginationInfiniteScroll();
        }
        else{
            // Pagination Numbers
            this.paginationNumbers();
        }

        // // Ajax Pagination
        // this.ajaxPagination();
    }


    paginationNumbers = () => {

        var paginationLinks = this.querySelectorAll('.products-pagination a');

        for( let link of paginationLinks ){
            link.addEventListener('click', (e) => {
                e.preventDefault();

                var href = link.getAttribute('href');
                var searchParams = href.replace(window.location.pathname + '?', '');

                if (Shopify.designMode) {
                    var pathToReplace = window.location.href.split('?')[0];
                    var searchParams = href.replace(pathToReplace + '?', '');
                }

                // Ajax Pagination
                ajaxPagination(searchParams, this);
            });
        }
    }

    paginationInfiniteScroll = () => {

        var infiniteButton = this.querySelector('.products-pagination-infinite:not(:disabled)');

        infiniteButton.addEventListener('click', (e) => {
            e.preventDefault();

            var newPage = parseInt(infiniteButton.dataset.currentPage) + 1;

            var searchParams = 'page=' + newPage;

            var getParams = window.location.href.split('?');

            if(getParams != ''){
                searchParams = searchParams + "&" + getParams[1];
            }
        
            infiniteButton.disabled = true;

            // Ajax Pagination
            ajaxPagination(searchParams, this);

        })

         window.addEventListener('scroll', function() {

            var productsPagination = document.querySelector('products-pagination');
            var infiniteButton = productsPagination.querySelector('.products-pagination-infinite:not(:disabled)');

            if(infiniteButton){
                if(productsPagination.dataset.paginationChoice == '3' && infiniteButton.dataset.currentPage != '1' && parseInt(infiniteButton.dataset.currentPage) < parseInt(infiniteButton.dataset.totalPages)){
                    var windowHeight = window.innerHeight;
                    var elementOffset = 100;

                    var elementPosition = infiniteButton.getBoundingClientRect();
                    if ((elementPosition.bottom + elementOffset) <= windowHeight) {

                        var newPage = parseInt(infiniteButton.dataset.currentPage) + 1;


                        var searchParams = 'page=' + newPage;

                        var getParams = window.location.href.split('?');

                        if(getParams != ''){
                            searchParams = searchParams + "&" + getParams[1];
                        }
                    
                        infiniteButton.disabled = true;

                        // Ajax Pagination
                        ajaxPagination(searchParams, productsPagination);
                    }
                }
            }
         });
        
    }



    ajaxPagination = () => {
        
        var paginationLinks = document.querySelectorAll('.products-pagination a');

        var productsSelector = '.products'
        var section = document.querySelector(productsSelector);

        for( let link of paginationLinks ){
            link.addEventListener('click', (e) => {
                e.preventDefault();

                var href = link.getAttribute('href');
                var searchParams = href.replace(window.location.pathname + '?', '');
                
                if (Shopify.designMode) {
                    var pathToReplace = window.location.href.split('?')[0];
                    var searchParams = href.replace(pathToReplace + '?', '');
                }

                fetch(`${window.location.pathname}?${searchParams}`)
                    .then(response => {
                        return response.text()
                    })
                    .then((text) => {

                        const html = document.createElement('div');
                        html.innerHTML = text;
                        const productsSection = html.querySelector(productsSelector);
                        
                        section.innerHTML = productsSection.innerHTML;

                        const resultsLazyloadImages = section.querySelectorAll('.lazy-loading-image');

                        resultsLazyloadImages.forEach(imageContainer => {
                            lazyloading(imageContainer);
                        })

                        updateURLState(searchParams)


                        document.querySelector('.section-products').scrollIntoView({
                            behavior: "instant"
                        })

                    });

            })
        }

    }
}

customElements.define( 'products-pagination', ProductsPagination )